import React from 'react';
import { Link } from 'react-router-dom';
import { heroFadeStyle } from './utils/heroFade';
import bullseyeBanner from './assets/images/bullseye-banner.jpeg';
import { useT } from './i18n';

const PILLARS = [
  { key: 'heroBe.target', value: 'heroBe.targetValue' },
  { key: 'heroBe.rounds', value: 'heroBe.roundsValue' },
  { key: 'heroBe.jackpot', value: 'heroBe.jackpotValue' },
];

const HeroBullsEye = () => {
  const t = useT();
  const backgroundImageStyle = {
    backgroundColor: '#000000',
    backgroundImage: `url(${bullseyeBanner})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    ...heroFadeStyle,
  };

  return (
    <section className="relative flex w-full items-center overflow-hidden">
      {/* Artwork layer, faded at the bottom so the hero dissolves into the page. */}
      <div aria-hidden="true" className="absolute inset-0" style={backgroundImageStyle}>
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/75 to-black/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-black/50" />
      </div>

      <div className="relative mx-auto w-full max-w-screen-2xl px-4 py-8 sm:px-8 sm:py-16 md:min-h-[420px] md:py-16 lg:px-10">
        <div className="max-w-2xl lb-animate-in">
          <span className="lb-chip lb-chip-cyan">
            <span className="lb-dot" aria-hidden="true" />
            {t('heroBe.badge')}
          </span>

          <h1 className="lb-heading mt-6 text-[2.25rem] leading-[0.98] sm:text-5xl lg:text-6xl">
            <span className="lb-gradient-text">BullsEye</span>
            <span className="mt-1 block text-2xl sm:text-3xl lg:text-4xl">
              {t('heroBe.subtitle')}
            </span>
          </h1>

          <p className="mt-4 max-w-xl font-medium text-sm leading-relaxed text-white/80 sm:mt-6 sm:text-lg">
            {t('heroBe.body')}
          </p>

          <div className="mt-6 flex flex-wrap gap-3 sm:mt-8">
            <Link to="/bullseye?section=game" className="lb-btn lb-btn-primary lb-btn-lg">
              {t('common.playNow')}
            </Link>
            <Link to="/bullseye?section=winners" className="lb-btn lb-btn-outline lb-btn-lg">
              {t('heroBe.seeWinners')}
            </Link>
          </div>

          {/* the game page repeats these facts; on phones the game comes first */}
          <dl className="mt-9 hidden max-w-xl gap-3 sm:grid sm:grid-cols-3">
            {PILLARS.map((item) => (
              <div
                key={item.key}
                className="rounded-2xl border border-white/10 bg-black/50 px-4 py-3 backdrop-blur"
              >
                <dt className="lb-label">{t(item.key)}</dt>
                <dd className="mt-1 text-sm font-semibold text-white">{t(item.value)}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

export default HeroBullsEye;
